import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Spa from './barba/Spa';
import Menu from './components/Menu';
import LibrarySlider from './components/LibrarySlider';
import LibraryArchive from './components/LibraryArchive';
import Collapse from './components/Collapse';
import Lottie from './components/Lottie';
import Anchors from './components/Anchors';

import './feature-detection';

export class SwitchLit {
	constructor() {
		Promise.all([SwitchLit.domReady()]).then(() => this.init());
	}

	init() {
		LibrarySlider.init();
		LibraryArchive.init();
		Collapse.init();
		Lottie.init();
		Anchors.init();
		new Menu();
		new Spa(); // Emits bless on before enter
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new SwitchLit();
